import React from 'react';

import styles from './DiscoverPlaylist.module.scss';
import {LikeCountButton} from '../../../../components';
import {Button} from '../../../../../../components';
import {useHistory} from 'react-router-dom';

interface Props {
  name: string;
  image: string;
  id: string;
}

export default function DiscoverPlaylist({name, image, id}: Props) {
  const history = useHistory();

  return (
    <div className={styles.DiscoverItem}>
      <div className={styles.Art}>
        <img alt="cover" src={image} />
        <div className={styles.ImageOverlay} />
      </div>
      <div className={styles.Details}>
        <h3 className={styles.Description}>
          <span className={styles.Name}>{name}</span>
        </h3>
        <div className={styles.ButtonContainer}>
          <Button
            onClick={() => {
              history.push(`/catalog/playlist/${id}`);
            }}
          >
            View Playlist
          </Button>
          <LikeCountButton likes={0} liked={false} />
        </div>
      </div>
    </div>
  );
}
